import {NgModule} from '@angular/core';
import {DecDmsPipe, RaHmsPipe} from './pipes/ra-dec.pipe';
import {SafePipe} from './pipes/safe.pipe';
import {StickyPopover} from './directives/sticky-popover.directive';
import {PublicationLinkDirective} from './directives/publication-link.directive';

@NgModule({
  declarations: [
    RaHmsPipe,
    DecDmsPipe,
    SafePipe,
    StickyPopover,
    PublicationLinkDirective,
  ],
  exports: [
    RaHmsPipe,
    DecDmsPipe,
    SafePipe,
    StickyPopover,
    PublicationLinkDirective,
  ]
})
export class AsaxCommonModule {
}
